import fpApiUtil from "./fp-api-util";

const ANALYSIS = "factoryplan/analysis";

// 주문 간트 차트 — AnalysisController#getActivities(order-gantt).
// 응답은 `{ data: [...] }` 래핑이 아니라 List<OrderGanttResultDto> 배열 자체이고, 각 노드가 자기
// 자식을 `items`에 재귀적으로 담은 트리다(OrderGanttService#makeTree). 부모 노드의 `anc`에는 자식
// id가 ";"로 이어붙어 있는데, 이게 old TreeGrid `GanttAncestors`가 그리던 **작업 순서 화살표의
// 데이터 소스**다(별도 API 없음) — reports/gantt-implementation.md §5-4.
const getActivities = (params) => fpApiUtil.postParams(`${ANALYSIS}/order-gantt/activities`, params);

// 바 툴팁 2종 — 주문(Level 0)은 작업지시 기준, 자식(공정/BOM)은 액티비티 기준으로 서로 다른
// 엔드포인트를 쓴다(old OnGanttTip의 row.Level 분기 그대로).
const getWoTooltip = (params) => fpApiUtil.postParams(`${ANALYSIS}/order-gantt/activity/tooltip/work-order`, params);
const getBomTooltip = (params) => fpApiUtil.postParams(`${ANALYSIS}/order-gantt/activity/tooltip/bom`, params);

const fpOrderGanttService = { getActivities, getWoTooltip, getBomTooltip };
export default fpOrderGanttService;
